import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppTagsInputComponent } from './tags-input.component';
import { FormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap';

@NgModule({
  imports: [CommonModule, FormsModule, TypeaheadModule.forRoot()],
  declarations: [AppTagsInputComponent],
  exports: [AppTagsInputComponent],
})
export class AppTagsInputModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AppTagsInputModule,
      providers: [],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/common/tags-input/tags-input.module.ts